/**
 * Time utilities for timezone-aware operations
 * Complements datetime.ts with additional helpers
 */
import { toUtcISOString } from './datetime'
// Default timezone for the application
export const LOCAL_TZ = 'America/Los_Angeles'
/**
 * Convert a local ISO string to UTC Date object
 * @param localISO - Local ISO string (e.g., "2024-01-15T14:00:00")
 * @param tz - IANA timezone (defaults to LOCAL_TZ)
 * @returns UTC Date object
 */
export function localISOToUtcDate(localISO: string, tz = LOCAL_TZ): Date {
  // Use the existing toUtcISOString utility to convert local to UTC
  const utcISO = toUtcISOString(localISO, tz)
  return new Date(utcISO)
}
/**
 * Convert a local ISO string to UTC ISO string
 * @param localISO - Local ISO string (e.g., "2024-01-15T14:00:00")
 * @param tz - IANA timezone (defaults to LOCAL_TZ)
 * @returns UTC ISO string
 */
export function localISOToUtcISO(localISO: string, tz = LOCAL_TZ): string {
  return toUtcISOString(localISO, tz)
}
